import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { firstRoute } from "../lib/perms";

// Landing page opened in a new tab to impersonate a user (token in ?t=).
export default function Impersonate() {
    const navigate = useNavigate();
    const { refresh } = useAuth();
    const ran = useRef(false);

    useEffect(() => {
        if (ran.current) return;
        ran.current = true;
        const t = new URLSearchParams(window.location.search).get("t");
        if (!t) { navigate("/login"); return; }
        sessionStorage.setItem("imp_token", t);
        window.history.replaceState(null, "", "/acessar-como");
        (async () => {
            const u = await refresh();
            navigate(u ? firstRoute(u) : "/login", { replace: true });
        })();
    }, [navigate, refresh]);

    return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-background">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
            <p className="mt-4 text-sm text-muted-foreground">Entrando na conta do usuário...</p>
        </div>
    );
}
